import { motion } from "framer-motion";
import type { FunnelSection } from "../../funnel/flowData";

type TopBarProps = {
  canGoBack: boolean;
  onBack: () => void;
  sections: FunnelSection[];
  sectionProgress: number[];
  isWelcomeStep?: boolean;
  useWelcomeChrome?: boolean;
};

export const TopBar = ({
  canGoBack,
  onBack,
  sections,
  sectionProgress,
  isWelcomeStep = false,
  useWelcomeChrome = false
}: TopBarProps) => {
  return (
    <header
      className={`top-bar ${useWelcomeChrome ? "top-bar-welcome" : ""} ${isWelcomeStep ? "top-bar-current-step-welcome" : ""}`}
    >
      <div className="top-bar-row">
        {canGoBack ? (
          <button
            type="button"
            className="back-button"
            onClick={onBack}
            aria-label="Go back"
          >
            ← Back
          </button>
        ) : (
          <div className="top-bar-spacer" />
        )}
        <p className={`brand-name ${useWelcomeChrome ? "brand-name-welcome" : ""}`}>
          {useWelcomeChrome ? "LUMI" : "Lumi"}
        </p>
        <div className="top-bar-spacer" />
      </div>

      <div className="progress-sections">
        {sections.map((section, index) => {
          const baseProgress = sectionProgress[index] ?? 0;
          const progress = isWelcomeStep ? (index === 0 ? 1 : 0) : baseProgress;
          const isActive = progress > 0 && progress < 1;
          const isDone = progress >= 1;

          return (
            <div key={section.label} className="progress-section">
              <div
                className={`progress-section-bar ${isActive ? "progress-section-bar-active" : ""} ${isDone ? "progress-section-bar-done" : ""}`}
              >
                <motion.span
                  className="progress-section-fill"
                  initial={false}
                  animate={{ width: `${progress * 100}%` }}
                  transition={{ duration: 0.48, ease: [0.22, 1, 0.36, 1] }}
                />
              </div>
              {!useWelcomeChrome && progress > 0 ? (
                <p className="progress-section-label">{section.label}</p>
              ) : null}
            </div>
          );
        })}
      </div>
    </header>
  );
};
